<template><div><h1>VUX V2.3.1 released</h1>
<h2><a href="/en/components/flow.html">Flow</a></h2>
<ul><li>[feature] new component</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[fix] Fix render-function-generated-content visibility issue #1409</li>
</ul>
<h2><a href="/en/components/picker.html">Picker</a></h2>
<ul><li>[feature] Add getNameValues Method #1418</li>
</ul>
<h2><a href="/en/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[fix] fix cell display value</li>
</ul>
<h2><a href="/en/components/toast.html">Toast</a></h2>
<ul><li>[feature] Add text method for plugin</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[feature] Add blur function #1422</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.1 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.1-100.vue?3b287d8d